import { Text, TextProps, TextStyle } from "react-native";
import { APP_VARIANT } from "../../../config/setting";
import { FontFamily } from "../../../config/typography";
import { isIOS } from "../../../helpers";
import { THEME_COLORS } from "../../../theme/constants/themeColors";
import { AvailableAppVariants } from "../../../theme/enums";

type Props = {
  value?: any;
  style?: TextStyle;
  color?: string;
  semiBold?: boolean;
  bold?: boolean;
  medium?: boolean;
  size?: number;
  textProps?: TextProps;
  children?: any;
  fontWeight?: string;
};
export default function CText(props: Props) {
  const {
    value,
    style,
    semiBold,
    bold,
    medium,
    size = 16,
    textProps = {},
    children,
    color = THEME_COLORS.textColor
  } = props;

  let fontFamily = bold
    ? FontFamily.Poppins_Bold
    : semiBold
      ? FontFamily.Poppins_SemiBold
      : medium
        ? FontFamily.Poppins_Medium
        : FontFamily.Poppins_Regular;

  if (APP_VARIANT === AvailableAppVariants.TataMotorsLite) {
    fontFamily = bold
      ? FontFamily.Inter_Bold
      : semiBold
        ? FontFamily.Inter_SemiBold
        : medium
          ? FontFamily.Inter_Medium
          : FontFamily.Inter_Regular;
  }

  return (
    <>
      <Text
        style={[
          {
            fontFamily: fontFamily,
            fontSize: size,
            color: color,
            marginTop: isIOS() ? 0 : (APP_VARIANT === AvailableAppVariants.TataMotorsLite ? 0 : 2),
            marginBottom: isIOS() ? 1 : 0,
            // lineHeight: '130%',
          },
          style
        ]}
        {...textProps}>
        {children ?? value}
      </Text>
    </>
  );
}
